import {portfolioActionTypes} from "./portfolio.actionTypes";
import {Network} from "../../../utils/network";
import {useSelector} from "react-redux";
import {selectLiveProbes} from "./portfolio.selector";
import {getCurrentRoute} from "../../../navigation/rootNavigation";

// let userInfo = useSelector(({ profile }) => profile.profileData);

export const getClosedMarket = data => {
  return async (dispatch, state) => {
    try {
      dispatch({
        type: portfolioActionTypes.CLOSED_MARKETS_LOADING,
      });
      const res = await Network.getClosedMarket(data);

      dispatch({
        type: portfolioActionTypes.CLOSED_MARKETS_SUCCESS,
        payload: res.data,
      });
    } catch (e) {
      dispatch({
        type: portfolioActionTypes.CLOSED_MARKETS_ERROR,
      });
    }
  };
};

export const getClosedMarketProbe = data => {
  return async (dispatch, state) => {
    try {
      const res = await Network.getClosedMarket(data);
      dispatch({
        type: portfolioActionTypes.CLOSED_MARKETS_SUCCESS_PROBE,
        payload: res.data?.historyRows,
      });
    } catch (e) {
      dispatch({
        type: portfolioActionTypes.CLOSED_MARKETS_ERROR_PROBE,
      });
    }
  };
};

export const setClosedSelectedEvent = item => {
  return async (dispatch, state) => {
    dispatch({
      type: portfolioActionTypes.SELECTED_CLOSED_PROBE,
      payload: item,
    });
  };
};

export const fetchLivePorfolio = (contestId, isTokenCheck) => {
  const eventId = {};
  const indexId = {};
  const probeIndex = {};
  return async (dispatch, state) => {
    try {
      dispatch({
        type: portfolioActionTypes.ACTIVE_MARKETS_LOADING,
      });
      let config;
      if (isTokenCheck) {
        config = {
          headers: {
            Authorization: isTokenCheck,
          },
        };
      }
      let res;
      if (contestId) {
        res = await Network.getLivePortfolioContest(
          {
            eventsStatus: "'A','F'",
            contest_id: contestId,
          },
          config,
        );
      } else {
        res = await Network.getLivePortfolio({eventsStatus: "'A','F'"}, config);
      }

      if (res?.data) {
        const userInfo = state().profile.profileData;
        if (true) {
          res.data.liquidity.map((data, index) => {
            eventId[data.id] = data;
            indexId[data.id] = index;
          });
          var a = {probes: [], liquidity: []};
          var b = [];

          res.data.probes.map(data => {
            if (eventId[data.id]) {
              data.liquidity = eventId[data.id];
              res.data.liquidity.splice(indexId[data.id], 1);
              // delete res.data.liquidity[indexId[data.id]]
            }

            probeIndex[data.id] = data;
            b = {...b, [data.id]: probeIndex[data.id]};

            a.probes.push(data.id);
          });
          var l = [];
          res.data.liquidity.map((data, index) => {
            a.liquidity.push(data.id);
            probeIndex[data.id] = data;
            l = {...l, [data.id]: probeIndex[data.id]};
          });
        }
        if (!contestId) {
          dispatch({
            type: portfolioActionTypes.ACTIVE_MARKETS_SUCCESS,
            payload: a,
          });
          dispatch({
            type: portfolioActionTypes.ACTIVE_MARKETS_LIQUIDITY,
            payload: l,
          });
          dispatch({
            type: portfolioActionTypes.ACTIVE_MARKETS_SUCCESS1,
            payload: b,
          });
        } else {
          dispatch({
            type: portfolioActionTypes.ACTIVE_MARKETS_SUCCESS_CONTEST,
            payload: a,
          });
          dispatch({
            type: portfolioActionTypes.ACTIVE_MARKETS_SUCCESS_CONTEST1,
            payload: b,
          });
        }
      }
    } catch (e) {
      dispatch({
        type: portfolioActionTypes.ACTIVE_MARKETS_ERROR,
      });
    }
  };
};

export const updateLiquidity = probe => {
  // if (getCurrentRoute() === 'Portfolio') {
  //   return;
  // }
  return async (dispatch, getState) => {
    const {data, probeId} = probe;
    const liveProbes = getState().portfolioReducer;

    let probesDetail = liveProbes?.data1[probeId];
    const probeIndex = (liveProbes?.data?.probes ?? []).findIndex(
      item => item === probeId,
    );
    const liquidityArr = liveProbes?.data?.liquidity;
    let liquidityDetail = liveProbes?.liquidityDetail[probeId] || {};
    //let liquidity = liveProbes?.data.liquidity;
    const liquidityIndex = (liquidityArr ?? []).findIndex(
      item => item === probeId,
    );
    //const probeDetail = probes[probeId];

    // Handle Delete Scenario
    if (probe?.action === "DELETE") {
      if (probeIndex > -1) {
        delete probesDetail?.liquidity;
        probesDetail = {...probesDetail};
        liveProbes.data1[probeId] = probesDetail;

        return dispatch({
          type: portfolioActionTypes.ACTIVE_MARKETS_SUCCESS1,
          payload: {
            ...liveProbes?.data1,
          },
        });
      }
      if (liquidityIndex) {
        delete liveProbes?.liquidityDetail[probeId];
        liquidityArr = liquidityArr
          .slice(0, liquidityIndex)
          .concat(liquidityArr.slice(liquidityIndex + 1));

        dispatch({
          type: portfolioActionTypes.ACTIVE_MARKETS_SUCCESS,
          payload: {
            ...liveProbes?.data,
            liquidity: liquidityArr,
          },
        });
        return dispatch({
          type: portfolioActionTypes.ACTIVE_MARKETS_LIQUIDITY,
          payload: {
            ...liveProbes?.liquidityDetail,
          },
        });
      }
    }

    // Handle Update Existing Scenario Probe
    if (probeIndex) {
      //probesDetail.liquidity = data;
      probesDetail = {...probesDetail, liquidity: data};
      liveProbes.data1[probeId] = probesDetail;

      // liveProbes.data1[probeId] = probes;

      return dispatch({
        type: portfolioActionTypes.ACTIVE_MARKETS_SUCCESS1,
        payload: {
          ...liveProbes?.data1,
        },
      });
    }

    // Handle Update Existing Liquidity Probe
    if (liquidityIndex > -1) {
      liquidityDetail = data;
      //const a = [...liquidityDetail]
      return dispatch({
        type: portfolioActionTypes.ACTIVE_MARKETS_LIQUIDITY,
        payload: {
          ...liveProbes?.liquidityDetail,
        },
      });
    }

    // Handle Insert of New Liquidity Alone
    if (liquidityIndex === -1 && probeIndex === -1) {
      liquidityArr.push(probeId);
      liveProbes.liquidityDetail = {
        ...liveProbes.liquidityDetail,
        [probeId]: data,
      };
      dispatch({
        type: portfolioActionTypes.ACTIVE_MARKETS_SUCCESS,
        payload: {
          ...liveProbes?.data,
          liquidity: liquidityArr,
        },
      });
      //liquidity.push({probeId: data});
      return dispatch({
        type: portfolioActionTypes.ACTIVE_MARKETS_LIQUIDITY,
        payload: {
          ...liveProbes?.liquidityDetail,
        },
      });
    }
  };
};

export const updatePortfolio = (probe, isContest) => {
  return async (dispatch, getState) => {
    const {data, probeId} = probe;
    const liveProbes = getState().portfolioReducer;

    let probes = isContest
      ? [].concat(liveProbes?.portfolioDataContest?.probes ?? [])
      : [].concat(liveProbes?.data?.probes ?? []);

    let liquidity = [].concat(liveProbes?.data?.liquidity ?? []);
    let liquidityDetail = liveProbes?.liquidityDetail ?? {};
    const probeSpecificObject = isContest
      ? liveProbes.portfolioDataContest1?.[probeId]
      : liveProbes?.data1[probeId];
    const probeIndex = (probes ?? []).findIndex(item => item === probeId);
    const liquidityIndex = liquidity.findIndex(item => item === probeId);

    // Handle all shares sold scenario
    if (probe?.action === "DELETE") {
      if (probeSpecificObject) {
        const toBeRemoved = probeSpecificObject;
        if (toBeRemoved.liquidity) {
          liquidity.push(probeId);
          liquidityDetail = {
            ...liquidityDetail,
            [probeId]: toBeRemoved.liquidity,
          };
        }

        probes = probes
          .slice(0, probeIndex)
          .concat(probes.slice(probeIndex + 1));
        if (isContest) {
          delete liveProbes?.portfolioDataContest1[probeId];
        } else {
          delete liveProbes?.data1[probeId];
        }
      }
      if (isContest) {
        dispatch({
          type: portfolioActionTypes.ACTIVE_MARKETS_SUCCESS_CONTEST,
          payload: {
            ...{probes, liquidity},
          },
        });
        return dispatch({
          type: portfolioActionTypes.ACTIVE_MARKETS_SUCCESS_CONTEST1,
          payload: {
            ...liveProbes?.portfolioDataContest1,
          },
        });
      } else {
        if (probeSpecificObject.liquidity) {
          dispatch({
            type: portfolioActionTypes.ACTIVE_MARKETS_LIQUIDITY,
            payload: {
              ...liquidityDetail,
            },
          });
        }
        dispatch({
          type: portfolioActionTypes.ACTIVE_MARKETS_SUCCESS1,
          payload: {
            ...liveProbes?.data1,
          },
        });
        return dispatch({
          type: portfolioActionTypes.ACTIVE_MARKETS_SUCCESS,
          payload: {
            ...{probes, liquidity},
          },
        });
      }
    }

    // Handle Updates to Existing Share which is not delete
    if (probeSpecificObject) {
      probes = {...probeSpecificObject, ...data};
      if (isContest) {
        liveProbes.portfolioDataContest1[probeId] = probes;
      } else {
        liveProbes.data1[probeId] = probes;
      }

      // probes = (liveProbes?.data?.probes ?? []).map(item => {
      //   if (item.id === probeId) {
      //     return {
      //       ...item,
      //       ...data,
      //     };
      //   }
      //   return item;
      // });
      if (isContest) {
        return dispatch({
          type: portfolioActionTypes.ACTIVE_MARKETS_SUCCESS_CONTEST1,
          payload: {
            ...liveProbes?.portfolioDataContest1,
          },
        });
      } else {
        return dispatch({
          type: portfolioActionTypes.ACTIVE_MARKETS_SUCCESS1,
          payload: {
            ...liveProbes?.data1,
          },
        });
      }
    }
    //new item added
    if (!probeSpecificObject) {
      const newItem = probe?.data;
      if (liquidityIndex > -1) {
        newItem.liquidity = liquidityDetail[probeId];
        liquidity.splice(liquidityIndex, 1);
        delete liquidityDetail[probeId];
      }
      probes = probes.concat(probeId);
      //probeIndex[data.id] = data;
      if (isContest) {
        liveProbes.portfolioDataContest1[probeId] = probes;
      } else {
        liveProbes.data1[probeId] = data;
      }

      probes = probes.sort(function (a, b) {
        return b - a;
      });

      if (isContest) {
        dispatch({
          type: portfolioActionTypes.ACTIVE_MARKETS_SUCCESS_CONTEST,
          payload: {
            ...{probes, liquidity},
          },
        });
        return dispatch({
          type: portfolioActionTypes.ACTIVE_MARKETS_SUCCESS_CONTEST1,
          payload: {
            ...liveProbes?.portfolioDataContest1,
          },
        });
      } else {
        if (liquidityIndex > -1) {
          dispatch({
            type: portfolioActionTypes.ACTIVE_MARKETS_LIQUIDITY,
            payload: {
              ...liquidityDetail,
            },
          });
        }
        dispatch({
          type: portfolioActionTypes.ACTIVE_MARKETS_SUCCESS,
          payload: {
            ...{probes, liquidity},
          },
        });
        return dispatch({
          type: portfolioActionTypes.ACTIVE_MARKETS_SUCCESS1,
          payload: {
            ...liveProbes?.data1,
          },
        });
      }
    }
  };
};
